import { format, formatDistanceToNowStrict, isValid, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = parseISO(iso);
  return isValid(date) ? format(date, 'dd/MM/yyyy HH:mm:ss', { locale: fr }) : '—';
}

export function formatTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = parseISO(iso);
  return isValid(date) ? format(date, 'HH:mm:ss', { locale: fr }) : '—';
}

/** "il y a 3 min" — repère principal de fraîcheur des positions. */
export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return 'Aucune position reçue';
  const date = parseISO(iso);
  if (!isValid(date)) return 'Aucune position reçue';
  return `il y a ${formatDistanceToNowStrict(date, { locale: fr })}`;
}

/** Valeur pour un <input type="datetime-local"> (heure locale). */
export function toDateTimeInput(iso: string): string {
  const date = parseISO(iso);
  if (!isValid(date)) return '';
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}`;
}

export function fromDateTimeInput(value: string): string | undefined {
  if (!value) return undefined;
  const date = new Date(value);
  return isValid(date) ? date.toISOString() : undefined;
}

export function formatMeters(meters: number | null | undefined): string {
  if (meters === null || meters === undefined) return '—';
  return meters >= 1000 ? `${(meters / 1000).toFixed(2)} km` : `${Math.round(meters)} m`;
}

export function formatSpeed(kmh: number | null | undefined): string {
  return kmh === null || kmh === undefined ? '—' : `${kmh.toFixed(1)} km/h`;
}

export const LOCATION_TYPE_LABELS: Record<string, string> = {
  gps: 'GPS',
  wifi: 'Wi-Fi',
  lbs: 'Réseau (LBS)',
  unknown: 'Non communiquée',
};

export const STATUS_LABELS: Record<string, string> = {
  online: 'En ligne',
  offline: 'Hors ligne',
  unknown: 'Statut non communiqué',
};
